import React, { Fragment } from "react";
import { Avatar, IconButton } from '@material-ui/core';
import { CategoryTag, Participant, Locale } from "../../core/api/model";
import { DashboardPanelListItem } from "../DashboardPanel";
import CustomIcon from "../../core/custom-icon";

export interface DashboardFavouritesParticipantsListItemProps {
  locale: Locale;
  participant: Participant;
  deleteFavourite: (elementId: number, categoryTag: CategoryTag) => void;
}

export const DashboardFavouritesParticipantsListItem = (props: DashboardFavouritesParticipantsListItemProps) => (
  <Fragment>

    <DashboardPanelListItem headline={`${props.participant.partName} ${props.participant.partSurname}`}
                            imageSlot={
                              <Avatar alt={`${props.participant.partName} ${props.participant.partSurname}`}
                                      src={props.participant.partPic?.url}>
                                <CustomIcon iconname='person'
                                            viewBox='0 0 16 16'
                                            fontSize='small'
                                />
                              </Avatar>
                            }
                            actionsSlot={
                              <Fragment>
                                <IconButton aria-label=''
                                            color='primary'
                                            onClick={() => props.deleteFavourite( props.participant.partId, CategoryTag.Participant )}
                                >
                                  <CustomIcon iconname='favourite' />
                                </IconButton>
                                <IconButton aria-label='mehr Informationen zum Teilnehmer'
                                            target='_blank'
                                            component='a'
                                            color='primary'
                                            href={props.participant.expoSiteLink[props.locale]}
                                >
                                  <CustomIcon iconname='arrowLong' />
                                </IconButton>
                              </Fragment>
                            } />
  </Fragment>
);
